(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Elemente die NIEMALS animiert werden sollen
  var SKIP_SELECTORS = [
    '.slideshow',
    '.slideshow-slide',
    '.section-slideshow',
    'slideshow-component',
    '.video-background',
    '.section-video-background',
    '.section-video',
    '.video-section',
    '.page-hero',
    '.banner-list',
    '.section-banner',
    '[class*="banner"]',
    '[class*="video"]',
    '[class*="slideshow"]',
  ];

  function shouldSkip(el) {
    // Nie animieren wenn Element selbst oder Elternteil ein Skip-Selektor ist
    for (var i = 0; i < SKIP_SELECTORS.length; i++) {
      try {
        if (el.matches(SKIP_SELECTORS[i])) return true;
        if (el.closest(SKIP_SELECTORS[i])) return true;
      } catch(e) {}
    }
    // Nie animieren wenn schon sichtbar im Viewport beim Laden
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) return true;
    return false;
  }

  // --- 1. Scroll reveal ---
  function initScrollReveal() {
    if (prefersReduced) return;

    // Nur diese sicheren Sektionen animieren
    var safeSelectors = [
      '.section-features',
      '.section-newsletter',
      '.section-rich-text',
      '.section-expandable',
      '.section-map',
      '.section-countdown',
      '.section-events',
      '.section-media-with-text',
      '.section-blog-post',
      '.section-contact',
    ];

    var elements = document.querySelectorAll(safeSelectors.join(','));

    elements.forEach(function(el) {
      if (el.hasAttribute('data-torpion-observed')) return;
      if (shouldSkip(el)) return;
      el.setAttribute('data-torpion-observed', 'true');
      el.classList.add('torpion-animate');
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('torpion-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.torpion-animate').forEach(function(el) {
      observer.observe(el);
    });
  }

  // --- 2. Stagger Produktkarten im Grid ---
  function initStaggerGrids() {
    if (prefersReduced) return;

    var grids = document.querySelectorAll('.product-grid, .grid.featured-collection-grid');

    grids.forEach(function(grid) {
      if (grid.hasAttribute('data-torpion-stagger')) return;
      if (shouldSkip(grid)) return;
      grid.setAttribute('data-torpion-stagger', 'true');

      var items = grid.querySelectorAll('.grid-item');
      var visibleCount = 0;

      items.forEach(function(item, idx) {
        // Erste Reihe (meist 3-4 Karten) sofort sichtbar lassen
        if (idx < 4) {
          // sofort sichtbar
          return;
        }
        item.classList.add('torpion-animate');
        item.style.transitionDelay = ((idx - 4) * 0.07) + 's';
      });

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('torpion-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -24px 0px' });

      grid.querySelectorAll('.torpion-animate').forEach(function(item) {
        observer.observe(item);
      });
    });
  }

  // --- 3. Section-Titel animieren (nur wenn nicht im Viewport) ---
  function initTitles() {
    if (prefersReduced) return;

    var titles = document.querySelectorAll(
      '.block-section-title:not([data-torpion-title])'
    );

    titles.forEach(function(el) {
      if (shouldSkip(el)) return;
      el.setAttribute('data-torpion-title', 'true');
      el.classList.add('torpion-animate');
    });

    var subtitles = document.querySelectorAll(
      '.block-section-subtitle:not([data-torpion-subtitle])'
    );

    subtitles.forEach(function(el) {
      if (shouldSkip(el)) return;
      el.setAttribute('data-torpion-subtitle', 'true');
      el.classList.add('torpion-animate');
      el.style.transitionDelay = '0.1s';
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('torpion-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -20px 0px' });

    document.querySelectorAll('[data-torpion-title], [data-torpion-subtitle]').forEach(function(el) {
      observer.observe(el);
    });
  }

  // --- 4. Media+Text Links/Rechts ---
  function initMediaWithText() {
    if (prefersReduced) return;

    var sections = document.querySelectorAll('.section-media-with-text');
    sections.forEach(function(section) {
      if (section.hasAttribute('data-torpion-mwt')) return;
      if (shouldSkip(section)) return;
      section.setAttribute('data-torpion-mwt', 'true');

      var media = section.querySelector('.media-with-text-media');
      var content = section.querySelector('.media-with-text-content');

      if (media) media.classList.add('torpion-animate-left');
      if (content) content.classList.add('torpion-animate-right');

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            if (media) media.classList.add('torpion-visible');
            if (content) setTimeout(function() { content.classList.add('torpion-visible'); }, 120);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      observer.observe(section);
    });
  }

  // --- 5. Back-to-top button ---
  function initBackToTop() {
    var btn = document.querySelector('.button-top');
    if (!btn) return;
    btn.style.transition = 'opacity 0.3s ease, transform 0.3s cubic-bezier(0.34,1.56,0.64,1)';
    btn.style.opacity = '0';
    btn.style.transform = 'translateY(12px) scale(0.9)';
    window.addEventListener('scroll', function() {
      if (window.scrollY > 400) {
        btn.style.opacity = '1';
        btn.style.transform = 'translateY(0) scale(1)';
      } else {
        btn.style.opacity = '0';
        btn.style.transform = 'translateY(12px) scale(0.9)';
      }
    }, { passive: true });
  }

  // --- Init ---
  function init() {
    initScrollReveal();
    initStaggerGrids();
    initTitles();
    initMediaWithText();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 150);
  });

})();
